module.exports = {
	"de-AT": {
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"el-GR": {
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"decimalDigits": 2
	},
	"en-IE": {
		"symbolOnLeft": true,
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"es-ES": {
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"it-IT": {
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"decimalDigits": 2
	},
	"nl-NL": {
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"decimalDigits": 2
	},
	"nl-BE": {
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"decimalDigits": 2
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/currency-formatter/localeFormats.json
// module id = 1010
// module chunks = 0